import { useCheckResetToken } from '@/modules/Users/Users.api';
import { ResetType } from '@/modules/Users/Users.schema';
import { useEffect, useState } from 'react';

interface Props {
  token: string;
  reset_type: ResetType;
}

export const useValidateResetToken = ({ token, reset_type }: Props) => {
  const check = useCheckResetToken();
  const [validToken, setValidToken] = useState<boolean | undefined>();

  useEffect(() => {
    check.mutate(
      { token, reset_type },
      {
        onSuccess: () => {
          console.log('Token validated');
          setValidToken(true);
        },
        onError: (error) => {
          console.error('Token validation failed:', error);
          setValidToken(false);
        },
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, reset_type]);

  return validToken;
};
